import { ConfigProvider, Input } from "antd";

export default function CustomInputText({
  value,
  onChange,
  placeholder,
  className,
  disabled = false,
  type = "text",
}) {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#00397d", // ✅ ใช้เป็นสี focus border ของ DatePicker
        },
      }}
    >
      <Input
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={className}
        disabled={disabled}
        type={type}
      />
    </ConfigProvider>
  );
}
